import React, { useState } from 'react';
import ManageGroupSelect from './SelectManageGroup';
import ParentDeviceSelect from './SelectParentDevice';
import BranchSelectMultiple from './SelectBranchMultiple';
import RouteSelect from './SelectRoute';
import MeterSizeSelect from './SelectMeterSize';

const FilterAdvance = ({ dataFilter, onChange }) => {
  const handleBranchChange = (branchValues) => {
    // Reset manage group and parent device when branch changes
    const newDataFilter = {
      ...dataFilter,
      branch: branchValues,
      manage_group: [],
      parent_device: []
    };
    onChange(newDataFilter);
  };

  const handleManageGroupChange = (manageGroupValues) => {
    // Reset parent device when manage group changes
    const newDataFilter = {
      ...dataFilter,
      manage_group: manageGroupValues,
      parent_device: []
    };
    onChange(newDataFilter);
  };

  const handleParentDeviceChange = (parentDeviceValues) => {
    onChange({
      ...dataFilter,
      parent_device: parentDeviceValues
    });
  };

  const handleRouteChange = (routeValues) => {
    onChange({
      ...dataFilter,
      route: routeValues
    });
  };

  return (
    <div style={{ width: '100%', paddingBottom: '0px' }}>
      <BranchSelectMultiple
        value={dataFilter?.branch}
        onChange={(values) => onChange({ ...dataFilter, branch: values })}
        onBranchChange={handleBranchChange}
      />

      <ManageGroupSelect
        value={dataFilter?.manage_group}
        onChange={(values) => onChange({ ...dataFilter, manage_group: values })}
        parentBranch={dataFilter?.branch}
        onManageGroupChange={handleManageGroupChange}
      />

      <ParentDeviceSelect
        value={dataFilter?.parent_device}
        onChange={handleParentDeviceChange}
        parentBranch={dataFilter?.branch}
        parentManageGroup={dataFilter?.manage_group}
      />
      <RouteSelect
        value={dataFilter?.route}
        onChange={(values) => onChange({ ...dataFilter, route: values })}
      />
      <MeterSizeSelect
        value={dataFilter?.meter_size}
        onChange={(values) => onChange({ ...dataFilter, meter_size: values })}
      />
    </div>
  );
};

export default FilterAdvance;
